import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  functions: [],
  geography: [],
  jobRole: "",
};

const accountSetupSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    accountSetupLocation(state, action) {
      state["geography"] = action.payload;
    },
    accountSetupRemoveLocation(state, action) {
      state["geography"] = state.geography.filter(
        (item) => item !== action.payload
      );
    },
    accountSetupJobRole(state, action) {
      state["jobRole"] = action.payload;
    },
    accountSetupFunction(state, action) {
      state["functions"] = action.payload;
    },
    addFunction(state, action) {
      state["functions"] = [...state?.functions, action.payload].flat();
    },
    removeFunction(state, action) {
      state["functions"] = state.functions.filter(
        (item) => item !== action.payload
      );
    },
  },
});

export const {
  accountSetupLocation,
  accountSetupRemoveLocation,
  accountSetupJobRole,
  accountSetupFunction,
  addFunction,
  removeFunction,
} = accountSetupSlice.actions;
export default accountSetupSlice.reducer;
